"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monthWorkHours = void 0;
/**
 * Максимальное количество рабочих часов в месяце
 */
exports.monthWorkHours = 160;
